export default "__VITE_ASSET__079583e2__"